export default function MySQL_COUNT() {
  return (
    <div>
      <h2>MySQL_COUNT</h2>    </div>
  );
}